import { HTTP_INTERCEPTORS } from '@angular/common/http';
// interceptors
import { AuthInterceptor } from './auth.interceptor';
//import { BodyInterceptor } from './body.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { SpaceRemoverInterceptor } from './space-remover.interceptor';
import { LoadingInterceptor } from './loading.interceptor';
//import { LoadingInterceptor } from './loading.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  addInterceptor(AuthInterceptor),
  addInterceptor(ErrorInterceptor),
  addInterceptor(SpaceRemoverInterceptor),
  //addInterceptor(LoadingInterceptor),
  /**
   * * added some custom property in body
   * TODO: Need to remove in final stage
   */
];

function addInterceptor<T>(interceptor: T) {
  return {
    provide: HTTP_INTERCEPTORS,
    useClass: interceptor,
    multi: true,
  };
}
